module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("CANNABIS")]), _vm._v(" "), _c('h1', {
    staticClass: "tp"
  }, [_c('em', [_vm._v("a history")])]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("MARTIN BOOTH")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Picador")]), _c('br'), _vm._v("\nA Thomas Dunne Book"), _c('br'), _vm._v("\nSt. Martin’s Press"), _c('br'), _vm._v("\nNew York")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7049e79c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 60
// module chunks = 0